function MaximizeIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 20 20'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M2.39874 2.39874C2.86758 1.9299 3.50346 1.6665 4.1665 1.6665H6.6665C7.12674 1.6665 7.49984 2.0396 7.49984 2.49984C7.49984 2.96007 7.12674 3.33317 6.6665 3.33317H4.1665C3.94549 3.33317 3.73353 3.42097 3.57725 3.57725C3.42097 3.73353 3.33317 3.94549 3.33317 4.1665V6.6665C3.33317 7.12674 2.96007 7.49984 2.49984 7.49984C2.0396 7.49984 1.6665 7.12674 1.6665 6.6665V4.1665C1.6665 3.50346 1.9299 2.86758 2.39874 2.39874ZM12.4998 2.49984C12.4998 2.0396 12.8729 1.6665 13.3332 1.6665H15.8332C16.4962 1.6665 17.1321 1.9299 17.6009 2.39874C18.0698 2.86758 18.3332 3.50346 18.3332 4.1665V6.6665C18.3332 7.12674 17.9601 7.49984 17.4998 7.49984C17.0396 7.49984 16.6665 7.12674 16.6665 6.6665V4.1665C16.6665 3.94549 16.5787 3.73353 16.4224 3.57725C16.2661 3.42097 16.0542 3.33317 15.8332 3.33317H13.3332C12.8729 3.33317 12.4998 2.96007 12.4998 2.49984ZM2.49984 12.4998C2.96007 12.4998 3.33317 12.8729 3.33317 13.3332V15.8332C3.33317 16.0542 3.42097 16.2661 3.57725 16.4224C3.73353 16.5787 3.94549 16.6665 4.1665 16.6665H6.6665C7.12674 16.6665 7.49984 17.0396 7.49984 17.4998C7.49984 17.9601 7.12674 18.3332 6.6665 18.3332H4.1665C3.50346 18.3332 2.86758 18.0698 2.39874 17.6009C1.9299 17.1321 1.6665 16.4962 1.6665 15.8332V13.3332C1.6665 12.8729 2.0396 12.4998 2.49984 12.4998ZM17.4998 12.4998C17.9601 12.4998 18.3332 12.8729 18.3332 13.3332V15.8332C18.3332 16.4962 18.0698 17.1321 17.6009 17.6009C17.1321 18.0698 16.4962 18.3332 15.8332 18.3332H13.3332C12.8729 18.3332 12.4998 17.9601 12.4998 17.4998C12.4998 17.0396 12.8729 16.6665 13.3332 16.6665H15.8332C16.0542 16.6665 16.2661 16.5787 16.4224 16.4224C16.5787 16.2661 16.6665 16.0542 16.6665 15.8332V13.3332C16.6665 12.8729 17.0396 12.4998 17.4998 12.4998Z'
        />
      </svg>
    </span>
  );
}

export default MaximizeIcon;
